module.exports = __webpack_public_path__ + "img/STERiGLIDE_05.418f431f.jpg";